import { render, staticRenderFns } from "./GlossaryLinkedPests.vue?vue&type=template&id=075e5f0b&"
import script from "./GlossaryLinkedPests.vue?vue&type=script&lang=js&"
export * from "./GlossaryLinkedPests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports